import { GroupField } from '@prismicio/client';
import {
  LoanUsesSliceCarouselPrimaryCardsItem,
  Simplify,
} from '../../../../../../../prismicio-types';
import { LoanUsesCard } from '../LoanUsesCard/LoanUsesCard';
import { Container } from '@/components';

import styles from './MobileCards.module.scss';

interface MobileCardProps {
  cards: GroupField<Simplify<LoanUsesSliceCarouselPrimaryCardsItem>>;
}

export const MobileCards = ({ cards }: MobileCardProps) => {
  return (
    <Container>
      <ul className={styles.list}>
        {cards.map((item, index) => (
          <li key={item.description}>
            <LoanUsesCard item={item} variant="mobile" index={index} />
          </li>
        ))}
      </ul>
    </Container>
  );
};
